/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx, type jsx as jsxType } from '@emotion/react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

const containerStyles = xcss({
	width: '100%',
	paddingTop: 'space.300',
	paddingBottom: 'space.400',
	paddingLeft: 'space.400',
	paddingRight: 'space.400',
});

const buttonContainerStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-evenly',
	gap: 'space.100',
});

const buttonStyles = xcss({
	width: '100%',
});

// css() required to do custom boxShadow
const scrolledStyles = css({
	// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
	boxShadow: '0px -8px 14px -14px rgba(0, 0, 0, 0.4)',
});

interface FooterProps {
	buttons?: React.ReactElement[];
	showDropShadow: boolean;
}

export const Footer = (props: FooterProps): jsxType.JSX.Element | null => {
	if (!props.buttons?.length) {
		return null;
	}

	return (
		<div css={[props.showDropShadow && scrolledStyles]}>
			<Box testId="sidebar-main-footer" as="footer" xcss={containerStyles}>
				<Box xcss={buttonContainerStyles}>
					{props.buttons?.map((Button, index) => (
						<Box key={index} xcss={buttonStyles}>
							{React.cloneElement(Button, { shouldFitContainer: true })}
						</Box>
					))}
				</Box>
			</Box>
		</div>
	);
};
